import { AlarmClock, Check, Loader2Icon, TriangleAlert } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import CountdownTimer from "./CountDown";

function ConsentModal({
  errorMessage,
  isLoading,
  startCounter,
  handleConsent,
  acceptConsentData,
  isAccepting,
  isDeclining,
  isAlreadyAccepted,
  timer,
  viewConsentData,
}) {
  // const formattedMessage = viewConsentData?.data?.message?.split("\n");

  return (
    <div className="inset-0 z-10 flex justify-center items-center w-screen overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center">
        <div className="relative overflow-hidden rounded-lg p-4 md:p-6 lg:p-14  bg-white text-left shadow-xl transition-all flex flex-col items-center justify-center">
          <div className="bg-white">
            <div className="flex items-center justify-center flex-col py-6">
              <div className="flex justify-center items-center gap-2">
                <div
                  className={`flex justify-center items-center bg-blue-100 p-3  ${acceptConsentData?.data?.consented || isAlreadyAccepted ? "bg-lime-100" :  isDeclining ? "bg-red-100": "bg-blue-100"}  rounded-full `}
                >
                  {acceptConsentData?.data?.consented || isAlreadyAccepted ? (
                    <Check
                      strokeWidth={2}
                      size={40}
                      className="text-lime-600 animate-bounce"
                    />
                  ) : (
                    <TriangleAlert className={`text-blue-700 animate-pulse ${ isDeclining && "text-red-600"}`} />
                  )}
                </div>
                <h3
                  id="modal-title"
                  className={`text-2xl lg:text-4xl text- font-bold leading-6  ${acceptConsentData?.data?.consented || isAlreadyAccepted ? "text-lime-600" : isDeclining ? "text-red-600":  "text-blue-500"}`}
                >
                  Consent{" "}
                  {isAlreadyAccepted || acceptConsentData?.data?.consented
                    ? "Accepted" : isDeclining ? "Declined"
                    : "Required"}
                </h3>
              </div>

              <div>
                <img
                  src="/media/consent.png"
                  alt=""
                  className="w-[200px] rounded-md h-auto"
                />
              </div>

              {isLoading && (
                <div className="flex justify-center items-center gap-4 py-4">
                  <p className="text-2xl font-bold animate-pulse">
                    Please Wait A Second...
                  </p>
                  <Loader2Icon
                    size={40}
                    className="animate-spin text-blue-600 "
                  />
                </div>
              )}

              {startCounter && (
                <div className="flex justify-center gap-4 py-4 items-center ">
                  <p className={` ${isDeclining && "text-red-700"} text-2xl`}>
                    You will get redirect {isDeclining ? "back in" : "in"}{" "}
                  </p>

                  <div className="flex flex-col gap-2 justify-center items-center ">
                    <div
                      className={` ${isDeclining ? "text-red-700" : "text-lime-600"} font-extrabold flex justify-center gap-2 items-center `}
                    >
                      <CountdownTimer
                        start={timer}
                        onComplete={() => console.log("Countdown finished")}
                      />
                    </div>
                    <div
                      className={`text-lg rounded-full  p-2  ${isDeclining ? "text-red-700 bg-red-100" : "text-lime-600 bg-lime-100"}`}
                    >
                      <span>Seconds</span>
                    </div>
                  </div>
                </div>
              )}

              {errorMessage && (
                <div className="text-2xl text-red-600">{errorMessage}</div>
              )}

              {viewConsentData && !isDeclining && (
                <div
                  className="max-w-3xl mx-auto p-6 bg-white rounded-xl shadow-md text-xs
               text-gray-700 space-y-3"
                  dangerouslySetInnerHTML={{
                    __html: viewConsentData?.data?.message,
                  }}
                />
              )}
            </div>
          </div>

          {!isAccepting && !isDeclining && (
            <div className="w-full px-4 py-3 gap-4 flex justify-center items-center">
              <button
                onClick={() => handleConsent("agree")}
                className=" w-full justify-center rounded-md hover:bg-black bg-blue-500 px-3 py-4 text-[16px] font-semibold text-white shadow-sm  sm:ml-3 "
                type="button"
              >
                Agree
              </button>
              <button
                onClick={() => handleConsent("decline")}
                className="mt-3  w-full justify-center rounded-md bg-white px-3 py-4 text-[16px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:text-white hover:bg-red-700 sm:mt-0 "
                type="button"
              >
                Decline
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}



// const formatConsentHTML = (html) => {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, "text/html");
//   const paragraphs = Array.from(doc.querySelectorAll("p"));

//   if (!paragraphs.length) return html;

//   // Extract content
//   const title = paragraphs[0]?.innerText;
//   const bulletPoints = paragraphs
//     .slice(1, paragraphs.length - 1)
//     .filter((p) => p.innerText.trim().startsWith("✅"));
//   const footer = paragraphs[paragraphs.length - 1]?.innerText;

//   // Build new structured HTML
//   return `
//     <h2 class="text-lg font-bold text-green-600 mb-4">
//       ${title}
//     </h2>

//     <ul class="space-y-2 mb-4">
//       ${bulletPoints
//         .map(
//           (item) => `
//         <li class="flex gap-2 text-gray-700">
//           <span class="text-green-500">✔</span>
//           <span>${item.innerText.replace("✅", "").trim()}</span>
//         </li>
//       `
//         )
//         .join("")}
//     </ul>

//     <p class="text-[11px] text-gray-500 italic">
//       ${footer}
//     </p>
//   `;
// };


export default ConsentModal;
